/* ==========================================================================
   ProductCardPackages > Client > Prototype
   ========================================================================== */
/* Modules */
const tippy = module.require('tippy.js');
const Image = require('@bluekiri/alexandria-contrib-components/components/image/client/js');
const { initTripAdvisor } = require('./image');

// Prototype
const prototype = {
    addEventListener() {
        // bind onclick
        this.onClick = this.onClick.bind(this);

        this.element.addEventListener('click', this.onClick);

        return this;
    },

    removeEventListener() {
        this.element.removeEventListener('click', this.onClick);

        return this;
    },

    onClick: function Fn(event = false) {
        const { soldOut } = this.config || {};

        if (soldOut) return this;

        /* stop default action */
        event.preventDefault();

        /* Prevent bubbling */
        event.stopPropagation();

        this.modal.modal.display();
        this.modal.actions.setTitle(this.config.dataModal.title);
        this.modal.actions.setImage(this.config.dataModal.image);
        this.modal.actions.setPrice(this.config.dataModal.price);
        this.modal.actions.setSearcher(this.config.dataModal.searcher);

        return this;
    },

    initModal() {
        // Modules
        // require modal-searcher client
        const ModalClient = module.require('../../../modal-searcher/client/js');

        // init Modal
        const modalElement = this.element.querySelector('[data-component="Modal"]');

        if (modalElement) {
            this.modal = ModalClient('[data-component="Modal"]', {
                ...this.config.modal
            });
        }
    },

    init() {
        // init modal
        if (this.config.initModal && this.config.initSearcher) {
            this.initModal();
        }

        // Image
        this.image = Image(`${this.selector} [data-component="Image"]`);
        initTripAdvisor(this);

        // tippy info description
        tippy(`${this.selector} [data-type="icon"]`, {
            arrow: true,
            arrowType: 'sharp',
            duration: 0,
            placement: 'bottom',
            theme: 'translucent base-dark highlights'
        });

        // Prepare modal
        if (this.element.dataset.modal && this.config.initSearcher) {
            this.config.dataModal = {
                ...JSON.parse(this.element.dataset.modal),
                ...this.config.dataModal
            };
            this.element.removeAttribute('data-modal');

            // add modal events to open modal
            this.addEventListener();
        }
    }
};

// Exports
module.exports = prototype;
